import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-inga-library',
  template: `
    <p>
      inga-library works!
    </p>
  `,
  styles: []
})
export class IngaLibraryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
